import { useCallback } from "react";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { CenterResult } from "components/CenterResult";

export const NotFound: React.FC<{}> = () => {
  const navigate = useNavigate();

  const { i18n } = useTranslation();

  const handleClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  return (
    <CenterResult
      status="404"
      title="404"
      subTitle={
        i18n.language === "it"
          ? "La pagina che stai cercando non esiste."
          : "Sorry, the page you visited does not exist."
      }
      extra={
        <Button type="primary" onClick={handleClick}>
          {i18n.language === "it" ? "Torna alla Home" : "Back Home"}
        </Button>
      }
    />
  );
};
